import React from 'react';
import { useSelector } from 'react-redux';

import { useLocalization } from 'redux/localization/utils/hooks';

import Edit from './Edit';
import Join from './Join';

const JoinOrEdit = (props) => {
  const { club } = props;
  const { t } = useLocalization();
  const customer = useSelector((state) => state.customer.data);

  let { joinText, editText } = props;
  if (!joinText) {
    joinText = t('clubSignup.signup.joinTheClub');
  }
  if (!editText) {
    editText = t('clubSignup.membership.editMembership');
  }

  if (!club) {
    return null;
  }

  if (!customer) {
    return <Join club={club} joinText={joinText} />;
  }
  const activeClubMembershipId = getActiveClubMembershipId(club, customer);

  if (!activeClubMembershipId) {
    return <Join club={club} joinText={joinText} />;
  }

  return <Edit clubMembershipId={activeClubMembershipId} editText={editText} />;
};

const getActiveClubMembershipId = (club, customer) => {
  if (!customer.clubs) {
    return null;
  }
  const activeClubMembership = customer.clubs.find((c) => {
    if (
      c.clubId === club.id &&
      new Date(c.signupDate) < new Date() &&
      (!c.cancelDate || new Date(c.cancelDate) > new Date())
    ) {
      return true;
    }
    return false;
  });
  if (activeClubMembership) {
    return activeClubMembership.clubMembershipId;
  }
  return null;
};

export default JoinOrEdit;
